import { Component, OnDestroy, OnInit } from '@angular/core';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { GenericResponse } from 'src/app/api-interfaces';
import { AuthService } from 'src/app/auth/auth.service';
import { FuncsService } from 'src/app/shared/funcs.service';
import { NotificationService, NotificationType } from 'src/app/shared/notification.service';
import { Filter, SearchData } from 'src/app/shared/search/search.model';
import { SearchService } from 'src/app/shared/search/search.service';
import { IdentityService } from '../identity.service';
import { Request } from './request.model';
import { RequestService } from './request.service';

@Component({
  selector: 'app-requests',
  templateUrl: './requests.component.html',
  styleUrls: ['./requests.component.sass']
})
export class RequestsComponent implements OnInit, OnDestroy {

  title: string = "Richieste";
  isRequest: boolean = true;
  requests = this.requestService.requests$;
  isSpinning$ = this.requestService.isSpinning$;

  allowedOperations: Array<string> = [];
  requestId: number;
  controlCodeVisible: boolean = false;
  errorOnUpload: boolean = false;
  total=0;
  destroy$ = new Subject<void>();

  filterStatus: Filter[] = [
    {text: "Approved", value: "APPROVED"},
    {text: "Issued", value: "ISSUED"},
    {text: "Created", value: "CREATED"},
    {text: "Canceled", value: "CANCELED"},
  ]

  constructor(
    public funcs: FuncsService,
    public searchService: SearchService,
    public requestService: RequestService,
    public identityService: IdentityService,
    public notificationService: NotificationService,
    public authService: AuthService,
  ) {
    this.allowedOperations = this.requestService.obtainAllowedOperations();
    this.searchService.searchData = SearchData.Requests;
    this.requestService.totalRequests.pipe(takeUntil(this.destroy$)).subscribe(totalRequests => this.total = totalRequests);

  }

  ngOnInit(): void {
    this.searchService.resetSearchFields();
  }

  getValidationErrorMessage(errors: any): string {
    return this.funcs.getValidationErrorMessage(errors);
  }

  canBeCancelled(request: Request): boolean {
    const isStatusAllowed: boolean = this.requestService.hasStatusAllowed();
    return (this.allowedOperations.includes('showCancelRequest') && !["APPROVED", "CANCELED", "ISSUED"].includes(request.status) && isStatusAllowed);
  }

  canBeApproved(request: Request): boolean {
    const isStatusAllowed: boolean = this.requestService.hasStatusAllowed();
    return (this.allowedOperations.includes('showApproveRequest') && request.status == "CREATED" && isStatusAllowed);
  }

  canDoAction(request: Request): boolean {
    return (this.canBeCancelled(request) || this.canBeApproved(request));
  }

  completeRequest(request: Request) {
    this.requestService.requestToComplete.next(request);
    this.identityService.currentViewChanged.next("completeRequest");
  }

  cancelRequest(requestId: number) {
    if ( !requestId ) {
      return
    }

    this.requestService.isSpinning.next(true);
    this.identityService.cancelRequest(requestId).subscribe(
      (response: GenericResponse) => {
        if (response["esito"] == "OK") {
          this.requestService.isSpinning.next(false);
          this.searchService.search();
        }
      },
      (err: any) => {
        this.requestService.isSpinning.next(false);
        this.notificationService.createNotification(NotificationType.ERROR, "Errore!", "Errore nell'eliminare la richiesta.")
      },
      () => { this.requestService.isSpinning.next(false); }
    );
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    const { pageSize, pageIndex, sort, filter } = params;
    this.searchService.pageIndex = pageIndex;
    if(this.searchService.filter && filter && this.searchService.filter[0].value != filter[0].value) {
      this.searchService.pageIndex = 1;
    }
    this.searchService.filter = filter;
    this.searchService.pageSize = pageSize;
    const currentSort = sort.find(item => item.value !== null);
    this.searchService.sortField = (currentSort && currentSort.key) || 'id';
    this.searchService.sortOrder = (currentSort && currentSort.value) || 'descend';
    this.searchService.search();
  }

  ngOnDestroy(): void {
    this.destroy$.complete();
  }
}
